import {
  LiveKitServerApiService,
  type LivekitServerDto,
  type LivekitServerRequestDto,
  type UpdateLivekitSecretRequestDto,
} from '../services/agents-management';

export type LivekitServerResponse = LivekitServerDto;
export type LivekitServerCreateRequest = LivekitServerRequestDto;
export type LivekitServerUpdateRequest = Omit<
  LivekitServerRequestDto,
  'apiSecret'
> & {
  apiSecret?: string;
};
export type LivekitServerSecretUpdateRequest = UpdateLivekitSecretRequestDto;

export const getLivekitServers = async (): Promise<
  Array<LivekitServerResponse>
> => {
  return LiveKitServerApiService.listLivekitServers();
};

export const getLivekitServer = async (
  id: string
): Promise<LivekitServerResponse> => {
  return LiveKitServerApiService.getLivekitServerById(id);
};

export const createLivekitServer = async (
  data: LivekitServerCreateRequest
): Promise<LivekitServerResponse> => {
  return LiveKitServerApiService.createLivekitServer(data);
};

export const updateLivekitServer = async (
  id: string,
  data: LivekitServerUpdateRequest
): Promise<LivekitServerResponse> => {
  return LiveKitServerApiService.updateLivekitServer(
    id,
    data as LivekitServerRequestDto
  );
};

export const deleteLivekitServer = async (id: string): Promise<void> => {
  return LiveKitServerApiService.deleteLivekitServer(id);
};

export const updateLivekitServerSecret = async (
  id: string,
  data: LivekitServerSecretUpdateRequest
): Promise<void> => {
  return LiveKitServerApiService.updateLivekitServerSecret(id, data);
};

export const assignLivekitServerToOrganization = async (
  serverId: string,
  organizationId: string
): Promise<void> => {
  return LiveKitServerApiService.assignOrganizationToLivekitServer(
    serverId,
    organizationId
  );
};

export const getLivekitServerByOrganization = async (
  organizationId: string
): Promise<LivekitServerResponse> => {
  return LiveKitServerApiService.getLivekitServerByOrganization(organizationId);
};
